import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetFrequently_asked_questions = z.any()
export type TagsGetFrequently_asked_questions = z.infer<typeof tagsGetFrequently_asked_questions>

export const responseGetFrequently_asked_questions = z.object({ "payload": z.array(z.object({ "id": z.string(), "question": z.string(), "answer": z.string(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }) })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetFrequently_asked_questions = z.infer<typeof responseGetFrequently_asked_questions>

interface IGetFrequently_asked_questions extends BaseMethodType {
  tags: TagsGetFrequently_asked_questions,
  response: ResponseGetFrequently_asked_questions
}
export const URL = '/frequently-asked-questions'
export const validation = {
  get: {
    tags: tagsGetFrequently_asked_questions,
    response: responseGetFrequently_asked_questions
  }
}
export interface Frequently_asked_questions extends BaseRouteType {
  get: IGetFrequently_asked_questions
}